<template>
  <div>
      <Auth/>

  </div>
</template>


<script>
import Auth from "@/components/login/Auth";

export default {
  components: {
    Auth,
  },
}
</script>